/* eslint-disable max-len */
import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { usePersistentUserLocalStorage as useUserLocalStorage } from '../../../hooks/useUserLocalStorage';

const STORAGE_KEY = 'withOwnership';

const WithOwnershipContext = createContext();

export const useWithOwnershipContext = () => useContext(WithOwnershipContext);

const initialValue = { showWithOwnership: false };

export const WithOwnershipProvider = ({ children }) => {
  const [withOwnershipConfig, setWithOwnershipConfig] = useUserLocalStorage(STORAGE_KEY, initialValue);

  const value = useMemo(() => ({
    withOwnershipConfig: withOwnershipConfig || false,
    setWithOwnershipConfig,
  }), [withOwnershipConfig]);

  return (
    <WithOwnershipContext.Provider value={value}>
      { children }
    </WithOwnershipContext.Provider>
  );
};

WithOwnershipProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
